import _ from "lodash";
export default (state: tcpinpoint.Tenancy[] = [], action: any) => {
	switch (action.type) {
		case "GET_TENANCY_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Tenancy], state, "id");
		case "GET_TENANCIES_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Tenancy[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
